/* eslint-disable no-magic-numbers */

export const MILLISECONDS_PER_SECOND = 1000;
export const SECONDS_PER_MINUTE      = 60;
export const MINUTES_PER_HOUR        = 60;
export const HOURS_PER_DAY           = 24;
export const DAYS_PER_WEEK           = 7;
export const HOURS_PER_WEEK          = 168;
export const MONTHS_PER_YEAR         = 12;

/** One second in milliseconds */
export const SECOND = MILLISECONDS_PER_SECOND;

/** One minute in milliseconds */
export const MINUTE = SECOND * SECONDS_PER_MINUTE;

/** One hour in milliseconds */
export const HOUR = MINUTE * MINUTES_PER_HOUR;

/** One day in milliseconds */
export const DAY = HOUR * HOURS_PER_DAY;

/** One week in milliseconds */
export const WEEK = DAY * DAYS_PER_WEEK;

/**
 * One non-leap year in milliseconds
 * (A year is 365.24219 days long)
 */
export const YEAR = DAY * 365.24;

/** One approximate non-leap year in milliseconds */
export const NORMAL_YEAR = DAY * 365;

/** One approximate leap year in milliseconds */
export const LEAP_YEAR = DAY * 366;

/** One approximate decade in milliseconds */
export const DECADE = 10 * YEAR;

/** One approximate half-year in milliseconds */
export const HALF_YEAR = YEAR / 2;

/** One approximate month in milliseconds */
export const AVERAGE_MONTH = YEAR / 12;


// module.exports =
export default {
  MILLISECONDS_PER_SECOND,
  SECONDS_PER_MINUTE,
  MINUTES_PER_HOUR,
  HOURS_PER_DAY,
  HOURS_PER_WEEK,
  DAYS_PER_WEEK,
  MONTHS_PER_YEAR,

  SECOND,
  MINUTE,
  HOUR,
  DAY,
  WEEK,
  YEAR,
  HALF_YEAR,
  NORMAL_YEAR,
  LEAP_YEAR,
  DECADE,
  AVERAGE_MONTH,
};
